<template><div><h1 id="funtrade-im-zusammenspiel-mit-weiteren-systemen" tabindex="-1"><a class="header-anchor" href="#funtrade-im-zusammenspiel-mit-weiteren-systemen"><span>funtrade im Zusammenspiel mit weiteren Systemen</span></a></h1>
<SpotlightDetails :spotlight="spotlight1" /></div></template>


<script setup>
import { ref } from 'vue'

const spotlight1 = {
  videos: [
    {
      id: "ebill1",
      url: "https://player.vimeo.com/video/1194662932?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      title: "Intro: eBill und eBill Donations",
      description: "Digitale Zahlungsprozesse verändern das Fundraising nachhaltig. In diesem Video zeigen wir, warum eBill für mittlere NPOs weit mehr ist als nur eine digitale Rechnung – und wie Organisationen dadurch Prozesse vereinfachen, Kosten reduzieren und Unterstützer:innen direkt im E-Banking erreichen können. Ausserdem werfen wir einen ersten Blick auf eBill Donation und das Potenzial digitaler Spendenanfragen im Schweizer Fundraising.",
      width: 640,
      height: 360,
      speaker: "Christian Davatz",
    },
    {
      id: "ebill2",
      url: "https://player.vimeo.com/video/1194662933?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      title: "Demo: Zusagen über eBill fakturieren",
      description: "Wie können mittlere NPOs digitale Zahlungsprozesse effizienter gestalten? Dieses Video zeigt, welche Rolle eBill und eBill Donation im modernen Fundraising spielen – von der einfachen Zahlungsabwicklung bis hin zu neuen Möglichkeiten der digitalen Spenderansprache direkt im E-Banking. Praxisnah, verständlich und mit Fokus auf die Herausforderungen wachsender Organisationen.",
      width: 640,
      height: 360,
      speaker: "Christian Davatz",
    }
  ]
}
</script>